import { create } from 'zustand';

interface PriceLabState {
	open: boolean;
	setOpen: (v: boolean) => void;
	toggle: () => void;
}

export const usePriceLabStore = create<PriceLabState>((set) => ({
	open: false,
	setOpen: (v) => set({ open: v }),
	toggle: () => set((s) => ({ open: !s.open })),
}));
